import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ApiService } from 'src/app/Services/api.service';
import { CommonServices } from 'src/app/Services/common.service';
import { MapService } from 'src/app/Services/map.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';

declare const mapUtilityMapBox;

@Component({
  selector: 'manage-vehicle',
  templateUrl: './vehicle.configuration.component.html',
  styleUrls: ['./vehicle.configuration.component.css']

})


export class VehicleConfigrationComponent {

  @Input() popup = false;
  @Input() selectedVehicle: any;
  @Input() routeData: any;
  @Output() close = new EventEmitter();
  @Output() changedVehicle = new EventEmitter();
  customActiveTap: string = 'AvailableVehicle';
  public optionTitlecase: boolean = false;
  public vehicleData = [];
  public vehiclelists: any = [];

  public manageVehicleMap: any;
  public pickupFromMap: boolean = false;
  markerId = 'manageVehicleSelection';
  markerRadiusId = 'manage-vehicle-radius';
  public vehicleLocation = {};
  mapSearchDebounceTimeOut = null;
  mapSearchDataLists = [];
  public showMap: boolean = false;

  public vehicleType = 'existing';

  mangaeVehicle: any = {
    reason: '',
    period: '',
    vehicle: '',
  };

  public newVehicleObj = {
    vehRegNo: '',
    imei: '',
    model: '',
    capacity: '',
    vendorName: '',
    driverName: '',
    driverNumber: '',
    location: '',
  }

  public minDate;
  public maxDate;
  public minFromDate;
  public defaultEDate;
  public invalidDate: boolean = false;
  public showDatePicker: boolean = false;

  public errorObject = {
    reason: '',
    period: ''
  };
  public formSubmitted: boolean = false;
  public tabChanged: boolean = false;

  constructor(
    public mapService: MapService,
    public api: ApiService,
    public comservice: CommonServices,
    private swal: SweetAlert,
  ) {
    if (this.manageVehicleMap) this.manageVehicleMap.onMapClick(($event) => this.mapClickEventListen($event));
  }


  ngOnInit() {
    this.getVehicleList();
  }

  getVehicleList() {
    if (this.routeData.fromDate && this.routeData.startTime && this.routeData.endTime) {
      const obj = {
        routeStartTime: this.getDecimalTime(this.routeData.startTime),
        routeEndTime: this.getDecimalTime(this.routeData.endTime),
      };
      if (this.routeData.routeType == 'occasional') {
        if (this.routeData.toDate == undefined || this.routeData.toDate == '') return;
        else {
          obj['fromDate'] = new Date(this.routeData.fromDate).getTime();
          obj['toDate'] = new Date(this.routeData.toDate).getTime();
          this.api.transportManagerOccasionalRouteAvailableVeh(obj).then((res: any) => {
            if (res.status == 'success') {
              this.loadVehicleList(res.data);
            }
          }).catch((err) => {
            console.log(err);
          });
        }
      }
      else {
        let apiMethodName = 'transportManagerRegularRouteAvailableVeh';
        if (this.routeData.routeType == 'openBooking') apiMethodName = 'transportManagerOBRouteAvailableVeh';
        obj['date'] = new Date(this.routeData.fromDate).getTime();
        this.api[apiMethodName](obj).then((res: any) => {
          if (res.status == 'success') {
            this.loadVehicleList(res.data);
          }
        })
      }
    }
  }

  getDecimalTime(time) {
    var hoursMinutes = String(time).split(/[.:]/);
    var hours = parseInt(hoursMinutes[0], 10);
    var minutes = hoursMinutes[1] ? parseInt(hoursMinutes[1], 10) : 0;
    return hours + minutes / 100;
  }

  loadVehicleList(data) {
    this.vehicleData = [...data];
    this.vehiclelists = data.map(item => {
      return {
        "name": item.vehRegNo.toUpperCase() + ' ' + item.model, value: item.vehRegNo,
        badge: item.capacity, badgeColor: 'light'
      }
    });

    // selected vehicle ignoring  
    this.vehiclelists.filter((veh, index) => {
      if (veh.value == this.selectedVehicle.vehRegNo) this.vehiclelists.splice(index, 1);
    });
  }

  actionMulti() {
    console.log()
  }
  getSelectedVehicle(e) {
    this.mangaeVehicle['vehicle'] = e.value;
    if (!this.tabChanged == this.formSubmitted) this.validation();
    console.log(this.mangaeVehicle);
  }
  removeVeh() {
    this.tabChanged = true;
    delete this.mangaeVehicle['vehicle'];
  }
  removeNewVeh() {
    this.tabChanged = true;
    this.customActiveTap = 'AvailableVehicle';
    this.vehicleType = "existing";
    Object.keys(this.newVehicleObj).forEach((item: any) => {
      delete this.mangaeVehicle[item];
    });
  }
  addNewVeh() {
    this.customActiveTap = 'AddNewVehicle';
    this.vehicleType = "temporary";
    this.removeVeh();
    this.loadMap();
    Object.keys(this.newVehicleObj).forEach((item: any) => {
      this.mangaeVehicle[item] = '';
    });
  }

  getFormDate(e) {
    this.patchPeriod(e);
    if (!this.tabChanged == this.formSubmitted) this.validation();
    this.mangaeVehicle['fromDate'] = '';
    this.mangaeVehicle['toDate'] = '';
    this.showDatePicker = true;

    /*     // fromDate and toDate restriction between route fromDate and toDate
     this.showDatePicker = false;    
     this.mangaeVehicle['fromDate']= this.routeData.fromDate;
     this.mangaeVehicle['toDate']= this.routeData.toDate;
     let toDate = new Date(this.routeData.toDate);
     this.maxDate = toDate.getFullYear()+"-"+this.comservice.pad(toDate.getMonth()+1)+"-"+this.comservice.pad(toDate.getDate());
     this.minFromDate = new Date().getFullYear()+"-"+this.comservice.pad(new Date().getMonth()+1)+"-"+this.comservice.pad(new Date().getDate());
     console.log(this.maxDate);
     setTimeout(()=>{ this.showDatePicker = true; },100);
     console.log(this.mangaeVehicle); */
  }
  dateFromAction(obj: any = {}, type) {
    obj.selectedDates.map((x: any) => {
      let timeStamp = x.getTime();
      let dateTimeStamp = new Date(timeStamp);
      this.mangaeVehicle[type] = timeStamp;
      if (type == 'fromDate') this.minFromDate = dateTimeStamp.getFullYear() + "-" + this.comservice.pad(dateTimeStamp.getMonth() + 1) + "-" + this.comservice.pad(dateTimeStamp.getDate());
      console.log(this.minFromDate);
    });
    if (!this.tabChanged && this.formSubmitted) this.validation();
  }
  patchPeriod(e) {
    this.mangaeVehicle['period'] = e && e.target && e.target.value;
  }
  patchReason(value) {
    this.mangaeVehicle['reason'] = value;
    if (!this.tabChanged && this.formSubmitted) this.validation();
  }
  removeFormDate(e) {
    this.patchPeriod(e);
    delete this.mangaeVehicle['fromDate'];
    delete this.mangaeVehicle['toDate'];
    if (!this.tabChanged && this.formSubmitted) this.validation();
  }
  patchVehicleCapacity(model) {
    if (model == 'Sedan') {
      this.mangaeVehicle.capacity = 4;
    }
    else if (model == 'Suv') {
      this.mangaeVehicle.capacity = 7;
    }
    else if (model == 'Auto' || model == 'Hatchback') {
      this.mangaeVehicle.capacity = 3;
    }
    else if (model == 'loadVehicle') {
      this.mangaeVehicle.capacity = 2;
    }
    else {
      this.mangaeVehicle.capacity = '';
    }
    if (!this.tabChanged && this.formSubmitted) this.validation();
  }
  // map content

  loadMap() {
    this.initMap();
    /* this.mapService.map("manageVehicleMap").then((map) => {
        this.manageVehicleMap = map;         
        this.manageVehicleMap.removeMarkerAll();
        this.manageVehicleMap.removeLineAll();
        this.manageVehicleMap.onMapClick(($event) => this.mapClickEventListen($event));          
    }).catch((error) => {
      console.log('Load Map Error',error);
    }); */
  }
  initMap() {
    try {
      const mapBoxKey = 'pk.eyJ1Ijoib3dlbmxhbWIiLCJhIjoiY2lleWljcnF4MDBiOXQ0bHR0anRvamtucSJ9.t3YnHHqvQZ8Y0MTCNy0NNw';
      const parent = this;
      if (mapBoxKey) {
        const MyMap1 = new mapUtilityMapBox();
        MyMap1.setup('manageVehicleMap', {
          key: mapBoxKey
        },
          function (map) {
            parent.manageVehicleMap = map;
            parent.showMap = true;
            parent.manageVehicleMap.onMapClick(($event) => parent.mapClickEventListen($event));
          });
      }
    } catch (error) {
      console.log(error);
    }
  }

  mapClickEventListen($event) {
    console.log($event);
    // if (this.pickupFromMap === false) return
    this.vehicleMarker($event['lngLat']['lat'], +$event['lngLat']['lng']);

    this.vehicleLocationChanged($event['lngLat']['lat'], +$event['lngLat']['lng'])

    this.latlngDrawRadius($event['lngLat']['lat'], $event['lngLat']['lng']);


    this.manageVehicleMap.onDrag([this.markerId], (e) => {
      // console.log(e.target._lngLat['lat']);
      this.vehicleLocationChanged(e.target._lngLat['lat'], e.target._lngLat['lng'])
      this.latlngDrawRadius(+e.target._lngLat['lat'], e.target._lngLat['lng']);
      // markerId
    });
  }

  vehicleMarker(lat, lng) {
    lat = +lat.toFixed(5); lng = +lng.toFixed(5);
    this.manageVehicleMap.marker(
      {
        id: this.markerId,
        content: '<div class="mumb_marker_pin" style="background: #686ab9;"></div>',
        lat: lat,
        lng: lng,
        draggable: true   // <<<<< Important
      }
    );
    this.manageVehicleMap.focus({
      lat: lat,
      lng: lng,
      zoom: 14
    });
  }

  vehicleLocationChanged(lat, lng) {
    this.vehicleLocation['lat'] = +lat.toFixed(5);
    this.vehicleLocation['lng'] = +lng.toFixed(5);
    this.manageVehicleMap.geocoder(
      `${lng},${lat}`, (res) => {
        try {
          const locations = res.features.map(function (i) { return { center: i.center, name: i.place_name } });
          this.vehicleLocation['name'] = locations[0]['name'];
          this.mangaeVehicle['location'] = locations[0]['name'];
          if (!this.tabChanged && this.formSubmitted) this.validation();
        } catch (er) { console.log(er) };
      });
  }

  latlngDrawRadius(lat, lng) {
    this.manageVehicleMap.drawCircle({
      name: this.markerRadiusId, // unique like id
      lat: +lat.toFixed(5), lng: +lng.toFixed(5),
      km: '0.3',
      color: "rgba(255,0,0,0.2)"
    });
  }
  mapSearchFind(location) {

    clearTimeout(this.mapSearchDebounceTimeOut);
    this.mapSearchDebounceTimeOut = setTimeout(() => {
      this.manageVehicleMap.geocoder(
        `${location}`, (res) => {
          try {
            // console.log(res.features);
            const locations = res.features.map(function (i) { return { center: i.center, name: i.place_name } });
            // this.pickupPoints[this.editIndex]['location'] = locations[0]['name'];
            this.manageVehicleMap.focus({
              lat: locations[0]['center'][1],
              lng: locations[0]['center'][0],
              zoom: 15
            });
            this.mapSearchDataLists = [];
            this.mapSearchDataLists = locations;
          } catch (er) { console.log(er) };
        });

    }, 600);

  }

  removeCircleAndMarker() {
    this.manageVehicleMap.removeMarker(this.markerId);
    this.manageVehicleMap.removeCircle(this.markerRadiusId);
  }

  switchTab() {
    this.manageVehicleMap.removeMarkerAll();
  }

  scrollToPageTop() {
    // This prevents the page from scrolling down to where it was previously.
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }
    // This is needed if the user scrolls down during page load and you want to make sure the page is scrolled to the top once it's fully loaded. This has Cross-browser support.
    window.scrollTo(0, 0);
  }

  _keyPress(event: any) {
    const pattern = /[0-9]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
    if (!this.tabChanged && this.formSubmitted) this.validation();
  }

  validation() {
    let objectKeys = Object.keys(this.mangaeVehicle);
    this.errorObject = {
      reason: '',
      period: ''
    };
    let isValid = true;
    this.errorObject['invalidDate'] = '';
    for (let i = 0; i < objectKeys.length; i++) {
      let key = objectKeys[i];
      this.errorObject[key] = '';
      if (this.mangaeVehicle[key] == '' || this.mangaeVehicle[key] == undefined || this.mangaeVehicle[key] == null || this.mangaeVehicle[key].length <= 0) {
        if (key == 'vehRegNo') {
          this.errorObject[key] = "Vehicle Registration Number is Required."
        }
        else {
          this.errorObject[key] = key.split(/(?=[A-Z])/).join(" ").toLowerCase() + ' is required.';
          if (!this.showDatePicker) { delete this.errorObject['fromDate']; delete this.errorObject['toDate']; }
        }
        isValid = false;
      } else if (key == 'fromDate' || key == 'toDate') {
        this.invalidDate = false;
        if ((this.mangaeVehicle.toDate != '') && this.mangaeVehicle.fromDate > this.mangaeVehicle.toDate) {
          isValid = false;
          this.invalidDate = true;
          this.errorObject['invalidDate'] = 'To Date is Invalid.';
        }
      }
      else if (key == 'vehRegNo') {
        const pattern = /^[A-Z|a-z]{2}[0-9]{1,2}[A-Z|a-z]{0,2}[0-9]{4}$/;
        let patternIsInvalid = this.patternCheckFn(pattern, this.mangaeVehicle[key]);
        if (patternIsInvalid) {
          isValid = false;
          this.errorObject[key] = 'Vehicle Registration Number is Invalid.'
        }
      }
      // else if( key == 'imei'){
      //   const pattern = /^[0-9]{14}$/;
      //   let patternIsInvalid = this.patternCheckFn(pattern,this.mangaeVehicle[key]);           
      //   if(patternIsInvalid){
      //     isValid = false;
      //     this.errorObject[key] = 'IMEI Number is Invalid.'
      //   }
      // }
      else if (key == 'driverNumber') {
        const pattern = /^[0-9]{10}$/;
        let patternIsInvalid = this.patternCheckFn(pattern, this.mangaeVehicle[key]);
        if (patternIsInvalid) {
          isValid = false;
          this.errorObject[key] = 'Driver Number is Invalid.'
        }

      }

    }
    return isValid;
  }

  patternCheckFn(pattern, value) {
    let checkInValid: boolean;
    const inputChar = value;
    checkInValid = pattern.test(inputChar);
    return !checkInValid;
  }

  /*   validation(){
        let isValid:boolean = true;
        Object.keys(this.mangaeVehicle).filter((key)=>{
            if(this.checkError(key)) isValid = false;
        })
        return isValid;
    }
   */
  onSubmit() {
    this.formSubmitted = true;
    this.tabChanged = false;
    let isValid = this.validation();

    let obj = {
      routeID: this.routeData.routeID,
      trasitMode: this.routeData.trasitMode,
      period: this.mangaeVehicle.period,
      vehicleType: this.vehicleType,
      oldVehicle: { ...this.selectedVehicle },
    };
    if (obj.period == 'temporary') {
      obj['fromDate'] = this.mangaeVehicle.fromDate;
      obj['toDate'] = this.mangaeVehicle.toDate;
    }

    if (obj.vehicleType == 'existing') {

      this.vehicleData.filter((veh) => {
        if (veh.vehRegNo == this.mangaeVehicle.vehicle) obj['newVehicle'] = { ...veh };
      });

    } else if (obj.vehicleType == 'temporary') {
      obj['newVehicle'] = {
        vehRegNo: this.mangaeVehicle.vehRegNo,
        imei: this.mangaeVehicle.imei,
        model: this.mangaeVehicle.model,
        capacity: this.mangaeVehicle.capacity,
        vendorName: this.mangaeVehicle.vendorName,
        driverName: this.mangaeVehicle.driverName,
        driverNumber: this.mangaeVehicle.driverNumber,
        location: this.vehicleLocation,
      };
    }
    console.log(obj);
    if (isValid) {
      this.api.transportManagerRouteVehicleSwap(obj).then((res: any) => {
        if (res.status == 'success') {
          this.swal.swalFunction(res.status.toLowerCase(), res.status, res.message, 2000);
          setTimeout(() => {
            this.closePopup();
            this.changedVehicle.emit(obj['newVehicle']);
          }, 3000);
        } else {
          this.swal.swalFunction('error', res.status, res.message, 2000);
        }
      })
    }
  }

  closePopup() {
    this.close.emit(true);
  }
}